import React from 'react';
import { initialize, reduxForm } from 'redux-form'
import FormGroup from '@material-ui/core/FormGroup';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { required, number, integer, positiveInteger, positiveNumber } from "../common/fieldValidators";
import TextField from "../common/fields/TextField";
import SelectField from "../common/fields/selectFields/SelectField";
import { TEST_TYPES_SERVICE } from '../common/services/availableServices';
import toastr from 'toastr';
import LoadingIndicator from "../common/components/LoadingIndicator";
import FormButtons from "../common/components/FormButtons";
import { constructErrorMessage, FormMode, initializeFormMode } from "../common/FormUtils";
import { compose } from "redux";
import { connect } from "react-redux";
import { translatable } from "react-multilingual";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from 'prop-types';
import image from '../img/geometrical.png'
import { FormLabel } from '@material-ui/core';
import Utils from '../common/Utils';
import { roles } from '../Auth/roles';

const Latex = require('react-latex');

const styles = () => ({
  root: {
    flexGrow: 1,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  inputField: {
    marginTop: 10,
    marginBottom: 10
  },
  buttonMargin: {
    marginRight: 32
  },
  markerMM: {
    position: 'absolute',
    left: '300px',
    top: '72px',
    maxWidth: '80px',
  },
  distMarkers: {
    position: 'absolute',
    left: '300px',
    top: '152px',
    maxWidth: '80px',
  },
  geometricalDimensions: {
    position: 'relative',
    '@media (min-width: 960px)': {
      flexBasis: '380px',
      maxWidth: '380px',
    }
  }
});

const reduxFormName = 'testDetails';

class TestDetails extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      testId: this.props.testId,
      formMode: initializeFormMode(this.props.testId),
      loading: false,
      isModified: false
    };

    this.editButtonClickHandler = this.editButtonClickHandler.bind(this);
    this.cancelButtonClickHandler = this.cancelButtonClickHandler.bind(this);
    this.closeButtonClickHandler = this.closeButtonClickHandler.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(initialize(reduxFormName, this.props.test));
  }

  closeButtonClickHandler() {
    if (this.state.isModified) {
      this.props.onSuccess();
    } else {
      this.props.onCancel();
    }
  }

  cancelButtonClickHandler() {
    this.setState({
      formMode: FormMode.VIEW,
    }, () => {
      this.props.dispatch(initialize(reduxFormName, this.props.test));
    });
  }

  editButtonClickHandler() {
    this.setState({
      formMode: FormMode.EDIT
    })
  }

  submitFormHandler = (values) => {
    if (FormMode.CREATE === this.state.formMode) {
      this.createTest(values);
    } else if (FormMode.EDIT === this.state.formMode) {
      this.updateTest(values, this.state.testId);
    }
  }

  createTest({ status, ...values }) {
    this.setState({
      loading: true,
    });

    TEST_TYPES_SERVICE.post(values).then(response => {
      this.setState({
        loading: false,
        isModified: true,
        formMode: FormMode.VIEW,
        testId: response.data.id,
      });

      this.props.dispatch(initialize(reduxFormName, {
        name: response.data.name,
        manufacturer: response.data.manufacturer,
        calibrationFormula: response.data.calibrationFormulaType,
        sampleType: response.data.sampleType,
        unit: response.data.unit,
        status: response.data.status,
        markerMM: response.data.markerMM,
        distMarkers: response.data.distMarkers,
      }));
      toastr.success(this.props.labels.test_details.testCreated);
    }).catch(error => {
      this.errorHandler(this.props.labels.test_details.testCreateError, error);
    });
  }

  updateTest({ status, ...values }, testId) {
    this.setState({
      loading: true,
    });

    TEST_TYPES_SERVICE.patch(testId, `/status?status=${status}`).then(response => {
      this.setState({
        loading: false,
        isModified: true,
        formMode: FormMode.VIEW,
      });
      this.props.dispatch(initialize(reduxFormName, {
        name: response.data.name,
        manufacturer: response.data.manufacturer,
        calibrationFormula: response.data.calibrationFormulaType,
        sampleType: response.data.sampleType,
        unit: response.data.unit,
        status: response.data.status,
        markerMM: response.data.markerMM,
        distMarkers: response.data.distMarkers,
      }));
      toastr.success(this.props.labels.test_details.testUpdated);
    }).catch(error => {
      this.errorHandler(this.props.labels.test_details.testUpdateError, error);
    });

    // TEST_TYPES_SERVICE.put(values, testId).then(response => {
    //   this.setState({
    //     loading: false,
    //     isModified: true,
    //     formMode: FormMode.VIEW,
    //   });
    //   this.props.dispatch(initialize(reduxFormName, {
    //     name: response.data.name,
    //     manufacturer: response.data.manufacturer,
    //     calibrationFormula: response.data.calibrationFormulaType,
    //     sampleType: response.data.sampleType,
    //     unit: response.data.unit,
    //     status: response.data.status,
    //     markerMM: response.data.markerMM,
    //     distMarkers: response.data.distMarkers,
    //   }));
    //   toastr.success(this.props.labels.test_details.testUpdated);
    // }).catch(error => {
    //   this.errorHandler("Can't update test.", error);
    // })
  }

  errorHandler(message, error) {
    this.setState({
      loading: false,
    });
    if (!error.handledGlobally)
      toastr.error(constructErrorMessage(message, error));
  }

  render() {
    const { handleSubmit, classes, labels } = this.props;
    const testDetailsLabels = labels.test_details;
    const { formMode, loading } = this.state;

    const disabled = (formMode === FormMode.VIEW || formMode === FormMode.EDIT || loading);

    return (
      <React.Fragment>
        {loading &&
          <LoadingIndicator />
        }
        <div style={{ padding: 16 }}>
          <form noValidate autoComplete="off" onSubmit={handleSubmit(this.submitFormHandler)}
            className={classes.container}>
            <Grid container spacing={32} style={{ overflow: 'auto' }}>
              <Grid item xs={12}>
                <Typography variant="h5" color={"primary"} gutterBottom>
                  {formMode === FormMode.CREATE ? testDetailsLabels.page_title_create : testDetailsLabels.page_title_edit}
                </Typography>
              </Grid>
              <Grid item xs={12} style={{ flex: 1 }}>
                <FormGroup>
                  <TextField
                    name="name"
                    label={testDetailsLabels.name}
                    className={classes.inputField}
                    required
                    validate={[required]}
                    disabled={disabled}
                  />
                  <TextField
                    name="manufacturer"
                    label={testDetailsLabels.manufacturer}
                    className={classes.inputField}
                    required
                    validate={[required]}
                    disabled={disabled}
                  />
                  <SelectField
                    name="calibrationFormula"
                    label={testDetailsLabels.calibrationFormula}
                    className={classes.inputField}
                    required
                    validate={[required]}
                    disabled={disabled}
                    optionmap={{
                      'CALPROSMART_FORMULA': <span style={{ fontSize: '1.35rem' }}><Latex>{Utils.calibrationFormulaData('CALPROSMART_FORMULA').formula}</Latex></span>,
                      'BLOODTEST_FORMULA': <span style={{ fontSize: '1.35rem' }}><Latex>{Utils.calibrationFormulaData('BLOODTEST_FORMULA').formula}</Latex></span>,
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} className={classes.geometricalDimensions}>
                <FormLabel style={{ marginBottom: 10, fontSize: '0.75rem', marginTop: 10, display: 'block' }}>{testDetailsLabels.geometricalDimensions} *</FormLabel>
                <img style={{ width: '280px', height: 'auto' }} src={image} alt={testDetailsLabels.geometricalDimensions} />
                <FormGroup>
                  <TextField
                    name="markerMM"
                    className={`${classes.inputField} ${classes.markerMM}`}
                    required
                    label=""
                    type="number"
                    inputProps={{ min: "1", step: "1" }}
                    validate={[required, number, integer, positiveNumber]}
                    disabled={disabled}
                  />
                  <TextField
                    name="distMarkers"
                    className={`${classes.inputField} ${classes.distMarkers}`}
                    required
                    label=""
                    type="number"
                    inputProps={{ min: "1", step: "1" }}
                    validate={[required, number, integer, positiveNumber]}
                    disabled={disabled}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} style={{ flex: 1 }}>
                <FormGroup>
                  <SelectField
                    name="sampleType"
                    label={testDetailsLabels.sampleType}
                    className={classes.inputField}
                    required
                    validate={[required]}
                    disabled={disabled}
                    optionmap={{
                      'BLOOD': testDetailsLabels.sampleTypes.BLOOD,
                      'FECES': testDetailsLabels.sampleTypes.FECES,
                      'URINE': testDetailsLabels.sampleTypes.URINE,
                    }}
                  />
                  <SelectField
                    name="unit"
                    label={testDetailsLabels.unit}
                    className={classes.inputField}
                    required
                    validate={[required]}
                    disabled={disabled}
                    optionmap={{
                      'MG_PER_KG': 'mg/kg',
                      'NG_PER_ML': 'ng/ml',
                    }}
                  />
                  <SelectField
                    name="status"
                    label={testDetailsLabels.status}
                    className={classes.inputField}
                    disabled={formMode === FormMode.CREATE || formMode === FormMode.VIEW || loading}
                    optionmap={{
                      'VALIDATION': testDetailsLabels.statuses.VALIDATION,
                      'IN_PRODUCTION': testDetailsLabels.statuses.IN_PRODUCTION,
                      'WITHDRAWN': testDetailsLabels.statuses.WITHDRAWN,
                    }}
                  />
                </FormGroup>
              </Grid>
            </Grid>
            <Grid container alignItems="center" justify="flex-end" spacing={8} style={{ marginTop: 10 }}>
              <FormButtons
                formMode={formMode}
                onCloseButtonClick={this.closeButtonClickHandler}
                onCancelButtonClick={this.cancelButtonClickHandler}
                onEditButtonClick={this.editButtonClickHandler}
                actionButtonDisabled={loading}
                editModeEnabled={this.props.user.roles.includes(roles.ADMINISTRATOR)}
              />
            </Grid>
          </form>
        </div>
      </React.Fragment>
    );
  }
}

TestDetails.propTypes = {
  testId: PropTypes.number,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func
};

const mapTranslationsToProps = ({ labels }) => ({ labels });

function mapStateToProps(state) {
  return {
    user: state.auth.user
  }
}

export default compose(
  connect(mapStateToProps, null),
  translatable(mapTranslationsToProps),
  withStyles(styles),
  reduxForm({
    form: reduxFormName
  })
)(TestDetails);
